var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "white",
    stroke: "#5E4DE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96875 10.6413L9.14208 8.46799C9.39875 8.21133 9.39875 7.79133 9.14208 7.53466L6.96875 5.36133",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.96875 10.6413L9.14208 8.46799C9.39875 8.21133 9.39875 7.79133 9.14208 7.53466L6.96875 5.36133",
    stroke: "#5E4DE0",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRightArrow);
export default __webpack_public_path__ + "static/media/CircleRightArrow.b9e3558547a06a255e3653e76fd581cc.svg";
export { ForwardRef as ReactComponent };